import { useIntl, defineMessages } from 'react-intl'
import List from '../../../../Components/shared/List'
import { Box, Link, Text, Heading } from '@homebotapp/hb-react-component-catalog'
import { HOMEOWNER_DIGEST_BOMB_BOMB_WINDOW_ERROR } from '../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

export const MSG = defineMessages({
  head: {
    id: 'BombBomb.panel.error.head',
    defaultMessage: 'Try the following fixes:'
  },
  bullet1: {
    id: 'BombBomb.panel.error.bullet1',
    defaultMessage: 'Log out and log back in'
  },
  bullet2: {
    id: 'BombBomb.panel.error.bullet2',
    defaultMessage: 'Disconnect and reconnect the BombBomb Power Up'
  },

  bullet3: {
    id: 'BombBomb.panel.error.bullet3',
    defaultMessage: 'Log in to BombBomb and verify you still have an active subscription'
  },

  bullet4: {
    id: 'BombBomb.panel.error.bullet4',
    defaultMessage: 'Ensure the card on file for your BombBomb subscription is not expired'
  },
  bullet5: {
    id: 'BombBomb.panel.error.bullet5',
    defaultMessage: 'Still having issues? More troubleshooting tips can be found here: {supportURL}'
  }
})

export const BOMB_BOMB_SUPPORT_URL = 'https://support.bombbomb.com/'

export const BombBombPanelContentError = () => {
  const intl = useIntl()

  return (
    <Box padding='4'>
      <Heading textAlign='left' size='sm' marginBottom='2'>
        {intl.formatMessage(MSG.head)}
      </Heading>
      <List.Bulleted>
        <Text size='sm' textAlign='left' marginBottom='2'>
          {intl.formatMessage(MSG.bullet1)}
        </Text>
        <Text size='sm' textAlign='left' marginBottom='2'>
          {intl.formatMessage(MSG.bullet2)}
        </Text>
        <Text size='sm' textAlign='left' marginBottom='2'>
          {intl.formatMessage(MSG.bullet3)}
        </Text>
        <Text size='sm' textAlign='left' marginBottom='2'>
          {intl.formatMessage(MSG.bullet4)}
        </Text>
        <Text size='sm' textAlign='left' marginBottom='2'>
          {intl.formatMessage(MSG.bullet5, {
            supportURL: (
              <Link
                size='xs'
                isExternal
                href={BOMB_BOMB_SUPPORT_URL}
                tracking={{
                  guid: 'gJF4HwPTQmkNjKwtTEh5Fx',
                  ui_context: HOMEOWNER_DIGEST_BOMB_BOMB_WINDOW_ERROR,
                  descriptor: BOMB_BOMB_SUPPORT_URL
                }}
              >
                {BOMB_BOMB_SUPPORT_URL}
              </Link>
            )
          })}
        </Text>
      </List.Bulleted>
    </Box>
  )
}
